// No Data | Healthy | Degraded | Mitigated | Critical
export type Status = -99 | -1 | 0 | 5 | 10;

export const StatusTypes = {
  noData: -99 as Status,
  healthy: -1 as Status,
  degraded: 0 as Status,
  mitigated: 5 as Status,
  critical: 10 as Status,
};

export enum StatusString {
  HEALTHY = "healthy",
  DEGRADED = "degraded",
  CRITICAL = "critical",
  NO_DATA = "noData",
  MITIGATED = "mitigated",
}

export enum StatusEnum {
  HEALTHY = "HEALTHY",
  DEGRADED = "DEGRADED",
  CRITICAL = "CRITICAL",
  NO_DATA = "NO_DATA",
  MITIGATED = "MITIGATED",
}

export type StatusKey = keyof typeof StatusEnum;

export enum CtoStatus {
  CANCELLED = 5,
  COMPLETED = 3,
  EXPIRED = 4,
  EXTENSION_REQUIRED = 2,
  LIVE = 1,
  UNDER_EVALUATION = 0,
}

export enum ControlStatus {
  COMPLETED = "COMPLETED",
  LAST_WEEK = "LAST_WEEK",
  ON_GOING = "ON_GOING",
  OVERDUE = "OVERDUE",
}

export enum ControlStatusEnum {
  COMPLETED = 0,
  LAST_WEEK = 1,
  ON_GOING = 2,
  OVERDUE = 3,
}

